import { createAction } from '@utils/helpers';
import * as actionTypes from './types';

export const fetchTransactions = createAction(actionTypes.FETCH_TRANSACTIONS);
export const fetchTransactionsSuccess = createAction(actionTypes.FETCH_TRANSACTIONS_SUCCESS);

export const facedError = createAction(actionTypes.ACTION_ERROR);
